import React from 'react';
import { RouteComponentProps } from 'react-router';
import { DisciplinesType } from '@om-fe/models';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import RedirectTo from '@om-fe/core/components/redirect-to/redirect-to';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { removeAccents } from '@om-fe/core/core/routing/provider';

export type EsportsPageProps = I18nContextInterface
    & RouteComponentProps;

export const EsportsPage = () => {
    const { gettext } = useI18NContext();

    return (
        <RedirectTo
            routeName={RouteNames.eSportsParent}
            routeParams={{
                disciplineName: 'esports',
                disciplineId: DisciplinesType.ElectronicSports,
                sportChildId: '0',
                sportChildName: removeAccents(gettext('All')),
            }}
        />
    );
}